import { render, staticRenderFns } from "./FieldEditor.vue?vue&type=template&id=5af40fba"
import script from "./FieldEditor.vue?vue&type=script&lang=js"
export * from "./FieldEditor.vue?vue&type=script&lang=js"
import style0 from "./FieldEditor.vue?vue&type=style&index=0&id=5af40fba&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports